<template>
  <div id="header">
    <som-header
      ref="header"
      app-name="Digital Guidelines"
      department-name="The Department of Technology, Management, and Budget"
      main-content-id="main-content"
      home-link="./"
    >
      <som-menu breakpoint="lg">
        <som-menu-item>
          <router-link to="how-to-use" exact-active-class="active" @click.native="closeMobileMenu">Getting Started</router-link>
        </som-menu-item>
        <som-menu-item>
          <router-link to="layout" :class="{ active: route !== '/how-to-use' && route !== '/page-templates' && route !== '/' }" @click.native="closeMobileMenu">{{uiComponentsTitle}}</router-link>
        </som-menu-item>
      </som-menu>
    </som-header>
    <som-mobile-subheader
      ref="mobileSubheader"
      :subheader-title="secondaryNavTitle"
      v-if="route !== '/how-to-use' && route !== '/page-templates' && route !== '/'"
    >
      <div class="overlay-menu">
        <div v-bind:key="section.label" v-for="section in sortedSections">
          <div v-bind:data-section-name="section.label">
            <ul class="navbar-nav flex-column">
              <li class="nav-section">{{section.label}}</li>
              <li class="nav-item" v-bind:key="option.name" v-for="option in section.options">
                <router-link class="nav-link" exact-active-class="active" v-bind:to="option.href" @click.native="closeMobileMenu">{{option.name}}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </som-mobile-subheader>
  </div>
</template>

<script>
import SECTIONS from '../utils/sections';

export default {
  name: "Header",
  data() {
    const uiComponentsTitle = "UI Components";
    return {
      hideSideNav: this.$route.meta.hideSideNav,
      secondaryNavTitle: uiComponentsTitle,
      uiComponentsTitle,
      sections: [ ...SECTIONS ],
    };
  },
  computed: {
    route() {
      return this.$route.path
    },
    sortedSections() {
      // Sort sections
      const sort = (a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        return 1;
      };
      return this.sections.map(section => {
        const newSection = section;
        newSection.options =
          section.label === "Layout"
            ? section.options
            : section.options.sort(sort);
        return newSection;
      });
    }
  },
  watch: {
    $route(to, from) {
      let activeLink = "";
      if (to.path === "/how-to-use") {
        activeLink = "nav-how-to-use";
      } else if (to.path === "/page-templates") {
        activeLink = "nav-page-templates";
      } else if (to.path !== "/") {
        activeLink = "nav-layout";
      }
      this.hideSideNav = to.meta.hideSideNav;
      this.secondaryNavTitle = to.meta.hideSideNav
        ? ""
        : this.uiComponentsTitle;
    }
  },
  methods: {
    closeMobileMenu() {
      this.$refs.header.closeMobileMenu();

      if (this.$refs.mobileSubheader) {
        this.$refs.mobileSubheader.closeMobileMenu();
      }
    }
  }
};
</script>

/* eslint-disable */
<style lang="sass?outputStyle=expanded" scoped="true">
  @import '../assets/scss/variables';
  .overlay-menu {
    .nav-section{
      text-align: center;
      font-weight: 700;
      padding: 1.5rem 0 .5rem 0;
    }
    .nav-link{
      text-align: center;
      font-weight: 400;
      font-size: .875rem;
      padding: .375rem 0;
      &.active{
        font-weight: 700;
        color: $primary;
      }
    } 
  }
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/Header.vue